import { useMatches } from 'react-router';
import type { PageLayoutElements } from './layout/PageLayout';

interface Match {
  handle: {
    routeName?: string;
    pageLayout?: PageLayoutElements;
    ensureRole?: 'user' | 'admin' | 'anonymous';
  };
}

function useRouteHandle() {
  const matches = useMatches();
  const {
    routeName = '',
    pageLayout = {},
    ensureRole,
  } = matches.reduce(
    (acc: Match['handle'], match) => ({
      ...acc,
      ...(match as Match).handle,
    }),
    {},
  );

  return { routeName, pageLayout, ensureRole };
}

export default useRouteHandle;
